export default __webpack_public_path__ + "static/media/Train.8474a25a.svg";